module.exports = __webpack_public_path__ + "d88243a4bd2b17b133f950cf7142cf5e.svg";